
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './carousel.css';

const slides = [
  {
    id: 1,
    image: '/supp.png',
    title: 'HSE Solutions & Consultancy',
    firstTitle: 'HSE Solutions',
    secondTitle: 'and Consultancy',
    subtitle: 'Safety awareness programs, emergency drills, and regulatory compliance training.',
    to:'/HSE-Solutions-and-Consultancy'
  },
  {
    id: 2,
    image: '/image3.png',
    title: 'Mechanical Works',
    firstTitle: 'Mechanical',
    secondTitle: 'Works',
    subtitle:'Maintenance and repair of mechanical systems and components.',
    to:'/Mechanical-Works'
  },
  {
    id: 3,
    image: '/fab1.png',
    title:"Metal Fabrications",
    firstTitle: 'Metal',
    secondTitle: 'Fabrications',
    subtitle: 'We fabricate and install durable metal components tailored to your specs.',
    to:'/Metal-Fabrication'
  },
  {
    id: 4,
    image: '/civil.png',
    title: 'Civil Works',
    firstTitle: 'Civil Works',
    secondTitle: '',
    subtitle: 'Infrastructure development and maintenance services.',
    to:'/Civil-Works'
  },
  {
    id: 5,
    image: '/procurement.jpg',
    title: 'General Procurement',
    firstTitle: 'General',
    secondTitle: 'Procurement',
    subtitle: 'Ensuring efficient project execution, and sourcing of materials',
    to:"/General-Procurement"
  },
];

function Carousel() {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 5000);

    return () => clearInterval(interval); 
  }, []);

  const navToPage =(data)=> {
     navigate(data);
  }

  return (
    <div className="carousel">

      {slides.map((slide, index) =>  (

          <div className={`carousel-slide ${index === currentIndex ? 'active' : ''}`}
            key={slide.id} style={{ backgroundImage: `url(${slide.image})` }}>
            {index === currentIndex && (
              <div className="carousel-content">
                <h1 className='wow animate__animated animate__fadeInUp' data-wow-duration='1.5s'>
                  {slide.firstTitle} <br/> {slide.secondTitle}
                </h1>
                <p className='wow animate__animated animate__fadeInUp' data-wow-duration='2s'>{slide.subtitle}</p>
                <button onClick={()=> navToPage(slide.to)} className='cta wow animate__animated animate__fadeInUp' data-wow-duration='2.5s'>Learn More →</button>
              </div>
            )}
          </div>

        )
      )}

      <div className="carousel-controls">
        <button onClick={handlePrev}>&larr;</button>
        <span>
          {String(currentIndex + 1).padStart(2, '0')} / {slides.length.toString().padStart(2, '0')}
        </span>
        <button onClick={handleNext}>&rarr;</button>
      </div>
      <div className="carousel-indicators">
        {slides.map((slide, index) => (
          <span key={slide.id} className={index === currentIndex ? 'active' : ''}>
            {slide.title}
          </span>
        ))}
      </div>
    </div>
  );
}

export default Carousel;